import {Helmet} from "react-helmet-async";
import {HiOutlineSparkles} from "react-icons/hi2";
import {Navigate} from "react-router";

import {Chip} from "@/components/chip/Chip.tsx";
import {useCurrentUserContext} from "@/components/context/hooks.ts";
import {Icon} from "@/components/icon/Icon.tsx";
import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {ANALYZER} from "@/lib/featureFlags.ts";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {isFreeTrialExpired} from "@/lib/userUtils.ts";
import {AnalyzerPageContent} from "@/pages/analyzer/AnalyzerPageContent.tsx";
import {AnalyzerStartOverButton} from "@/pages/analyzer/components/AnalyzerStartOverButton.tsx";
import {AnalyzerProvider} from "@/pages/analyzer/hooks/AnalyzerContext.tsx";

import styles from "./AnalyzerPage.module.scss";

export const AnalyzerPage = () => {
  const {user, userHasFeature} = useCurrentUserContext();

  if (!userHasFeature(ANALYZER)) {
    return <Navigate to="/access-denied" />;
  }

  if (isFreeTrialExpired(user)) {
    return <Navigate to="/feature-unavailable" />;
  }

  return (
    <>
      <Helmet>
        <title>Assistant</title>
      </Helmet>
      <AnalyzerProvider>
        <ContentContainer
          title={
            <div className={styles.title}>
              Uptime Assistant
              <Chip variant="new" size="smallMedium" className={styles.newChip}>
                <Icon icon={HiOutlineSparkles} removeDivDimensions />
                New
              </Chip>
            </div>
          }
          actionsBar={<AnalyzerStartOverButton />}
          fullHeight
        >
          <UpErrorBoundary>
            <AnalyzerPageContent />
          </UpErrorBoundary>
        </ContentContainer>
      </AnalyzerProvider>
    </>
  );
};
